module.exports = new __parcel__URL__("sw_generative_empty.d5215f16.png").toString();